import React from 'react'
import { Helmet } from 'react-helmet'
import { organizationsWithCover } from 'config/constants/themeDefaults/layoutBox'
import { homeEditUrl } from 'config/constants/urls'
import HomeEdit from 'src/sites/kits/Home/apps/Edit'
import HomeMoreButton from 'src/sites/kits/Home/components/MoreButton'
import HomeTmpLayout from 'src/sites/kits/Home/components/TmpLayout'
import ModalRoute from 'src/sites/kits/Utils/ModalRoute'
import EyeQHomeLayout from 'src/sites/custom/eyeq/Home'
import FuseHomeLayout from 'src/sites/custom/fuse/Home'
import GNS3HomeLayout from 'src/sites/custom/gns3/Home/Layout'
import MotherWebsiteHomeLayout from 'src/sites/custom/mother-website/Home'
import ToolTerminalHomeLayout from 'src/sites/custom/tool-terminal/Home'
import { useOrganization } from 'src/core/graphql/hooks'

const customLayouts = {
   eyeq: EyeQHomeLayout,
   fuse: FuseHomeLayout,
   gns3: GNS3HomeLayout,
   'mother-website': MotherWebsiteHomeLayout,
   'tool-terminal': ToolTerminalHomeLayout
}

const Home = () => {
   const { organization } = useOrganization()
   const { currentUserCanEdit, name } = organization
   const hasHomeCover = organizationsWithCover.includes(organization.slug)
   const defaultLayout = HomeTmpLayout
   const Layout = customLayouts[organization.slug] || defaultLayout

   return (
      <>
         <Helmet title={name} />
         {!hasHomeCover && <Layout />}
         {currentUserCanEdit && <HomeMoreButton />}
         <ModalRoute path={homeEditUrl}>
            {({ open, onCloseComplete, onCloseTrigger }) => (
               <HomeEdit
                  modalOnCloseComplete={onCloseComplete}
                  modalOnCloseTrigger={onCloseTrigger}
                  modalOpen={open}
                  onCloseButtonClick={onCloseTrigger}
                  onUpdate={onCloseTrigger}
               />
            )}
         </ModalRoute>
      </>
   )
}

export default Home
